import { http, onSuccess, onFail } from "./http";

export const quizGetByEvent = (eventKey, params) =>
    http.get(`/api/cp/event/${eventKey}/quiz`, { params })
        .then(onSuccess, onFail);

export const quizGetByKey = (quizId, params) =>
    http.get(`/api/cp/event/quiz/${quizId}`, { params })
        .then(onSuccess, onFail);

export const quizCreate = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/quiz`, data)
        .then(onSuccess, onFail);

export const quizUpdate = (quizId, data) =>
    http.post(`/api/cp/event/quiz/${quizId}`, data)
        .then(onSuccess, onFail);

export const quizDelete = (quizId) =>
    http.delete(`/api/cp/event/quiz/${quizId}`)
        .then(onSuccess, onFail);

export const quizLaunch = (quizId) =>
    http.post(`/api/cp/event/quiz/${quizId}/modal`)
        .then(onSuccess, onFail);

export const quizStop = (quizId) =>
    http.delete(`/api/cp/event/quiz/${quizId}/modal`)
        .then(onSuccess, onFail);

export const quizzesOrderUpdate = (eventKey, payload) =>
    http.post(`/api/cp/event/${eventKey}/quiz/sort`, payload)
        .then(onSuccess, onFail);

// Quiz Questions

export const quizQuestionsGet = (quizId) =>
    http.get(`/api/cp/event/quiz/${quizId}/question`)
        .then(onSuccess, onFail);

export const quizQuestionGet = (questionId) =>
    http.get(`/api/cp/event/quiz/question/${questionId}`)
        .then(onSuccess, onFail);

export const quizQuestionCreate = (quizId, data) =>
    http.post(`/api/cp/event/quiz/${quizId}/question`, data)
        .then(onSuccess, onFail);

export const quizQuestionUpdate = (questionId, data) =>
    http.post(`/api/cp/event/quiz/question/${questionId}`, data)
        .then(onSuccess, onFail);

export const quizQuestionDelete = (questionId) =>
    http.delete(`/api/cp/event/quiz/question/${questionId}`)
        .then(onSuccess, onFail);

// Quiz Question Answers

export const quizQuestionAnswersGet = (questionId) =>
    http.get(`/api/cp/event/quiz/question/${questionId}/answer`)
        .then(onSuccess, onFail);

export const quizQuestionAnswerGet = (answerId) =>
    http.get(`/api/cp/event/quiz/question/answer/${answerId}`)
        .then(onSuccess, onFail);

export const quizQuestionAnswerCreate = (questionId, data) =>
    http.post(`/api/cp/event/quiz/question/${questionId}/answer`, data)
        .then(onSuccess, onFail);

export const quizQuestionAnswerUpdate = (answerId, data) =>
    http.post(`/api/cp/event/quiz/question/answer/${answerId}`, data)
        .then(onSuccess, onFail);

export const quizQuestionAnswerDelete = (answerId) =>
    http.delete(`/api/cp/event/quiz/question/answer/${answerId}`)
        .then(onSuccess, onFail);

// Quiz Partners

export const quizPartnersGet = (quizId) =>
    http.get(`/api/cp/event/quiz/${quizId}/partner`)
        .then(onSuccess, onFail);

export const quizPartnerGet = (partnerId) =>
    http.get(`/api/cp/event/quiz/partner/${partnerId}`)
        .then(onSuccess, onFail);

export const quizPartnerCreate = (quizId, data) =>
    http.post(`/api/cp/event/quiz/${quizId}/partner`, data)
        .then(onSuccess, onFail);

export const quizPartnerUpdate = (partnerId, data) =>
    http.post(`/api/cp/event/quiz/partner/${partnerId}`, data)
        .then(onSuccess, onFail);

export const quizPartnerDelete = (parnerId) =>
    http.delete(`/api/cp/event/quiz/partner/${parnerId}`)
        .then(onSuccess, onFail);

// Quiz Final Screen

export const quizFinalScreenUpdate = (quizId, data) =>
    http.post(`/api/cp/event/quiz/${quizId}/finalScreen`, data)
        .then(onSuccess, onFail);

// Quiz Results

export const getQuizResultsReport = (quizId, params) =>
    http.get(`/api/cp/event/quiz/${quizId}/report`, { params })
        .then(onSuccess, onFail);
